let $ = require('jquery');
let Backbone = require("backbone");
let POS = require("../POS.js");

let main = function () {
    var HelpModalView = Backbone.View.extend({
        el: "#helpModal",

        events: {
            'click .helpBlock': 'helpBlockClicked'
        },
        show: function () {
            if (window.location.hash.indexOf('settings') > 0) {
                this.options.tooltips.show();
            }
            POS.get("restaurant").showTipBear = true;
            $.post("/pos/setTipBear", {showStatus: true});
            this.$el.modal("show");
        },
        hide: function () {
            this.$el.modal("hide");
        },
        helpBlockClicked: function (e) {
            this.hide();
            return true;
        }
    });

    return HelpModalView;
};

let exportedValue = main();
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/view/HelpModalView.js